import { render, staticRenderFns } from "./TravelServiceOrderItemInsuranceChip.vue?vue&type=template&id=3ade3ce4&scoped=true&"
import script from "./TravelServiceOrderItemInsuranceChip.vue?vue&type=script&lang=js&"
export * from "./TravelServiceOrderItemInsuranceChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade3ce4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ade3ce4')) {
      api.createRecord('3ade3ce4', component.options)
    } else {
      api.reload('3ade3ce4', component.options)
    }
    module.hot.accept("./TravelServiceOrderItemInsuranceChip.vue?vue&type=template&id=3ade3ce4&scoped=true&", function () {
      api.rerender('3ade3ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Chips/TravelServiceOrderItemInsuranceChip.vue"
export default component.exports